import { useColorTheme } from '../../hooks/useColorTheme/useColorTheme'
import { useDateTimeFmt } from '../../hooks/useDateTimeFmt/useDateTimeFmt'

import { DatePicker as SharedDatePicker, DatePickerProps as SharedDatePickerProps } from '@percent/domain/giving'
import { theme as lemonadeTheme } from '@percent/lemonade'

export type DatePickerProps = Omit<SharedDatePickerProps, 'colorTheme' | 'formatDate'>

export function DatePicker(props: DatePickerProps) {
  const { theme } = useColorTheme()
  const { formatDateWODay } = useDateTimeFmt()

  // WPG's date fields can sit on the same page as their own confirm/success/error modals
  // (Modal zIndex 1210). Default the popover below that instead of the shared component's
  // 2000, so the calendar never covers a modal opened on top of it. See GT-3085.
  return (
    <SharedDatePicker
      zIndex={Number(lemonadeTheme.zIndex.select)}
      {...props}
      colorTheme={theme}
      formatDate={formatDateWODay}
    />
  )
}
